// extracted by mini-css-extract-plugin
export default {"modalBody":"ChangeWorkstreamModal-module__modalBody___F8yPm","assignmentUpdateWarning":"ChangeWorkstreamModal-module__assignmentUpdateWarning___lR1Gr"};